export const addWatermark = (html: string, watermarkText: string) => `
  <div style="
      position: fixed;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(-30deg);
      font-size: 5rem;
      color: rgba(0, 0, 0, 0.15);
      font-weight: bold;
      pointer-events: none;
      user-select: none;
      z-index: 9999;
      text-align: center;
  ">
      ${watermarkText}
  </div>
  ${html}
`;
